"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDateTime = exports.renderField = exports.renderTextArea = exports.renderDropdown = exports.renderRadio = exports.renderCheckbox = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactDatetime = _interopRequireDefault(require("react-datetime"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var renderCheckbox = function renderCheckbox(field) {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Checkbox, {
    checked: !!field.input.value,
    name: field.input.name,
    label: field.label,
    onChange: function onChange(e, _ref) {
      var checked = _ref.checked;
      return field.input.onChange(checked);
    }
  });
};

exports.renderCheckbox = renderCheckbox;

var renderRadio = function renderRadio(field) {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Radio, {
    checked: field.input.value === field.label.toLowerCase(),
    label: field.label,
    name: field.input.name,
    onChange: function onChange(e, _ref2) {
      var checked = _ref2.checked;
      return field.input.onChange(field.label.toLowerCase());
    }
  });
};

exports.renderRadio = renderRadio;

var renderDropdown = function renderDropdown(field) {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Select, (0, _extends2["default"])({
    label: field.label,
    name: field.input.name,
    onChange: function onChange(e, _ref3) {
      var value = _ref3.value,
          name = _ref3.name;

      // changeEventValidation is a function that can be passed to renderDropdown
      // to control whether or not we want to let the form be updated based on name and value of the field
      // If component has on change validations
      if (!!(field !== null && field !== void 0 && field.changeEventValidation)) {
        // only set new value if validation is passed
        if (field !== null && field !== void 0 && field.changeEventValidation(name, value)) {
          field.input.onChange(value);
        }

        return;
      } // If there are no onChange validation, set new value


      field.input.onChange(value);
    },
    options: field.options,
    placeholder: field.placeholder,
    value: field.input.value,
    clearable: true,
    selectOnBlur: false
  }, field));
};

exports.renderDropdown = renderDropdown;

var renderTextArea = function renderTextArea(field) {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.TextArea, (0, _extends2["default"])({}, field.input, {
    label: field.label,
    placeholder: field.placeholder
  }));
};

exports.renderTextArea = renderTextArea;

var renderField = function renderField(_ref4) {
  var input = _ref4.input,
      _ref4$meta = _ref4.meta,
      touched = _ref4$meta.touched,
      error = _ref4$meta.error,
      warning = _ref4$meta.warning,
      rest = (0, _objectWithoutProperties2["default"])(_ref4, ["input", "meta"]);
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, (0, _extends2["default"])({}, input, {
    error: touched && error,
    className: touched && warning ? 'warning' : undefined
  }, rest, {
    autoComplete: "off"
  })));
};

exports.renderField = renderField;

var renderDateTime = function renderDateTime(_ref5) {
  var _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$input = _ref5.input,
      input = _ref5$input === void 0 ? {} : _ref5$input,
      inputProps = _ref5.inputProps,
      placeholder = _ref5.placeholder,
      startDate = _ref5.startDate,
      _ref5$timeFormat = _ref5.timeFormat,
      timeFormat = _ref5$timeFormat === void 0 ? false : _ref5$timeFormat,
      _ref5$clearable = _ref5.clearable,
      clearable = _ref5$clearable === void 0 ? false : _ref5$clearable,
      rest = (0, _objectWithoutProperties2["default"])(_ref5, ["defaultValue", "input", "inputProps", "placeholder", "startDate", "timeFormat", "clearable"]);
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react["default"].createElement(_reactDatetime["default"], (0, _extends2["default"])({
    className: "ui input",
    inputProps: _objectSpread({
      placeholder: placeholder,
      readOnly: 'true',
      value: !(0, _lodash.isEmpty)(input.value) && (!timeFormat ? _reactDatetime["default"].moment(input.value).format('MM/DD/YYYY') : _reactDatetime["default"].moment(input.value).format('MM/DD/YYYY h:mma')) || defaultValue
    }, inputProps),
    defaultValue: input.value || defaultValue,
    viewDate: input.value || startDate,
    timeFormat: timeFormat,
    onChange: function onChange(currentDate) {
      if ((0, _lodash.isEmpty)(currentDate)) {
        input.onChange('');
      } else if (!timeFormat) {
        input.onChange(_reactDatetime["default"].moment(currentDate._d).format('YYYY-MM-DD'));
      } else {
        input.onChange(_reactDatetime["default"].moment(currentDate._d).utc().format());
      }
    },
    closeOnSelect: true,
    renderInput: function renderInput(props) {
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Input, (0, _extends2["default"])({}, props, props.inputProps, {
        icon: clearable && !(0, _lodash.isEmpty)(input.value) && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
          name: "times",
          link: true,
          onClick: function onClick() {
            return props.onChange({
              target: {
                value: null
              }
            });
          }
        })
      }));
    }
  }, rest)));
};

exports.renderDateTime = renderDateTime;